/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import ReactDOM from "react-dom";
import type { IModalInstance } from "./ModalService";
import { Modal, modalService as globalModalService, ModalService } from "./ModalService";
import { observer } from "mobx-react-lite";
import { LocalizationProvider as MuiXLocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs as MuiXAdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getSupportedDayjsLocale } from "@whatslly/commons/browserUtils";

const locale = getSupportedDayjsLocale();

export type { IModalInstance };

export const ModalProvider = observer(() => {
  return (
    <MuiXLocalizationProvider dateAdapter={MuiXAdapterDayjs} adapterLocale={locale}>
      <React.Fragment>
        {globalModalService.modalInstances.map((modal: Modal<any>) => {
          const Component = modal.Component;
          return ReactDOM.createPortal(<Component closeModal={modal.close} {...modal.props} />, document.body);
        })}
      </React.Fragment>
    </MuiXLocalizationProvider>
  );
});

export const ModalProviderInline: React.FC<{ modalService?: ModalService }> = observer(({ modalService = globalModalService }) => {
  return (
    <MuiXLocalizationProvider dateAdapter={MuiXAdapterDayjs} adapterLocale={locale}>
      <React.Fragment>
        {modalService.modalInstances.map((modal: Modal<any>, index) => {
          const Component = modal.Component;
          return <Component key={index} closeModal={modal.close} {...modal.props} />;
        })}
      </React.Fragment>
    </MuiXLocalizationProvider>
  );
});
